export default __webpack_public_path__ + "static/media/Systemic impacts.7de92e41.pdf";